import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const carouselStyles = css`
	.select {
		width: 250px;
	}

	.options-button {
		font-size: 14px;
		border-color: ${colors.border};
		margin-left: 10px;

		:hover {
			color: ${colors.mainText};
			border-color: ${colors.border};
			background-color: ${colors.background};
		}

		svg {
			margin-right: 5px;
		}
	}

	.theme-colors {
		display: flex;
		align-items: flex-start;
	}

	.color-boxes-block {
		margin-left: 20px;
	}

	.color-boxes {
		display: flex;
		flex-wrap: wrap;
	}

	.color-box {
		width: 25px;
		height: 25px;
		border-radius: 3px;
		box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px inset;
		margin-right: 10px;
		margin-bottom: 5px;
		cursor: pointer;
		position: relative;
	}

	.color-box.selected {
		border: 1px solid black;
		box-shadow: none;
		box-shadow: 0 0 0 5px rgba(37, 99, 235, 0.5);
		outline: 2px solid white;
	}

	.slides-container-header {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.label {
			font-size: 14px;
			color: ${colors.labelText};
		}

		.add-slide-button {
			margin-left: 10px;
			padding: 6px;
			border: 1px solid ${colors.border};
			border-radius: 4px;
			display: inline-flex;

			:hover {
				background-color: ${colors.background};
			}

			svg {
				color: ${colors.labelText};
				width: 20px;
				height: 20px;
			}
		}
	}

	.slides-container {
		margin-top: 10px;
		padding: 15px;
		background-color: ${colors.background};
	}

	.slides-grid-preview {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		padding: 20px 0;
	}
`;

export const slideStyles = css`
	border: 1px solid ${colors.border};
	border-radius: 4px;
	margin-bottom: 10px;

	.header {
		display: flex;
		justify-content: space-between;
		padding: 10px 16px;
		color: #495057;
		border-radius: 4px;
		background-color: white;
	}

	.slide-body {
		display: flex;
		gap: 20px;
		padding: 10px 16px;
		background-color: white;
	}

	.options-icon {
		position: relative;
	}
`;

export const slideDropdownStyles = css`
	position: absolute;
	top: -10px;
	left: 45px;
	z-index: 1;
	font-weight: 100;
	background-color: ${colors.background};
	width: max-content;
	cursor: default;

	.dropdownItem {
		display: flex;
		align-items: center;
		cursor: pointer;

		:hover {
			background-color: #f5f5f5;
		}
	}

	svg {
		margin-right: 10px;
	}
`;
